import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// import { useTranslation } from "react-i18next";
// import cx from "classnames";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import MenuIcon from "@material-ui/icons/Menu";
import CloseIcon from "@material-ui/icons/Close";

// core components
import Button from "components/CustomButtons/Button.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

// import config from "config/config.js";

import styles from "assets/jss/material-dashboard-pro-react/components/adminNavbarStyle.js";
// import sidebarStyle from "assets/jss/material-dashboard-pro-react/components/sidebarStyle.js";

const useStyles = makeStyles(styles);
// const useStylesLogo = makeStyles(sidebarStyle);

export default function MobileNavbar(props) {
  const classes = useStyles();
  // const classesLogo = useStylesLogo();
  const {
    brandText,
    handleDrawerToggle,
    customStyle
  } = props;

  return (
    <AppBar
      className={classes.appBar}
      style={{ backgroundColor: 'transparent', position: "fixed" }}
      // className={classes.appBar + appBarClasses}
    >
      <GridContainer>
        <GridItem xs={6} sm={6} md={6} lg={6}>
      {/*    {logo ? brand : null}*/}
        </GridItem>
        <GridItem xs={6} sm={6} md={6} lg={6}>
          <div
            style={{
              textAlign: "right",
              marginRight: "15px"
            }}
          >
            <Button
              className={classes.menuButton}
              onClick={handleDrawerToggle}
              color={"whiteOnly"}
            >
              {brandText === "sidebar" ? (
                <CloseIcon />
              ) : (
                <>
                  <MenuIcon
                    style={{
                      color: customStyle.buttonAction
                    }}
                  />
                </>
              )}
            </Button>
          </div>
        </GridItem>
      </GridContainer>
    </AppBar>
  );
}

MobileNavbar.propTypes = {
  cart: PropTypes.arrayOf(PropTypes.object).isRequired,
  webLink: PropTypes.string,
  logo: PropTypes.string,

  color: PropTypes.oneOf([
    "primary",
    "info",
    "success",
    "warning",
    "danger",
    "white"
  ]),
  rtlActive: PropTypes.bool,
  brandText: PropTypes.string,
  miniActive: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
  sidebarMinimize: PropTypes.func,
  customStyle: PropTypes.object
};

MobileNavbar.defaultProps = {
  webLink: "#",
  logo: "",

  color: "white",
  rtlActive: false,
  brandText: "",
  miniActive: false,
  handleDrawerToggle: null,
  sidebarMinimize: () => {},
  customStyle: {}
};
